import {
  Home as HomeIcon,
  Bolt as BoltIcon,
  WaterDrop as WaterIcon,
  School as SchoolIcon,
  Construction as ConstructIcon,
  Campaign as CampaignIcon,
  Handshake as HandshakeIcon,
  Palette as DesignIcon,
  Science as ResearchIcon,
  AttachMoney as FinanceIcon,
} from "@mui/icons-material";

export const programs = [
  {
    icon: <HomeIcon sx={{ fontSize: 40 }} />,
    
    name: " Solid Stabilized Earth Block",
    desc: "Building sustainable homes using  Solid Stabilized Earth Block made  — solving housing deficits while combating plastic waste pollution across African communities.",
    status: "Ongoing",
    color: "#1a6b3c",
    gradient: "linear-gradient(135deg,#2d9c5a,#1a6b3c)",
    image: " Solid Stabilized Earth Block.jpg",   // e.g. recycled plastic bricks / houses in Ghana or Kenya
  },
  {
    icon: <BoltIcon sx={{ fontSize: 40 }} />,
    
    name: "Biogas Project",
    desc: "Implementing clean, affordable biogas solutions for underserved communities — replacing harmful fuels with sustainable energy and reducing environmental impact.",
    status: "Ongoing",
    color: "#e85d04",
    gradient: "linear-gradient(135deg,#f48c06,#e85d04)",
    image: "biogas-community-africa.jpg",    // e.g. household or small plant biogas setup in rural Tanzania/Kenya
  },
  {
    icon: <WaterIcon sx={{ fontSize: 40 }} />,
    
    name: "Future Water Solutions",
    desc: "Upcoming water purification initiatives expanding access to safe, sustainable water for communities facing critical shortages across Sub-Saharan Africa.",
    status: "Upcoming",
    color: "#0369a1",
    gradient: "linear-gradient(135deg,#0284c7,#0369a1)",
    image: "clean-water-africa-community.jpg", // e.g. water well, purification point or happy community members
  },
  {
    icon: <SchoolIcon sx={{ fontSize: 40 }} />,
   
    name: "Scholarship Chapter",
    desc: "Empowering African youth through scholarships, CV writing webinars, and capacity-building programs to unlock global opportunities.",
    status: "Ongoing",
    color: "#f59e0b",
    gradient: "linear-gradient(135deg,#fbbf24,#f59e0b)",
    image: "african-youth-scholarship.jpg",   // e.g. young Africans in education setting, workshop, or graduation
  },
];

export const values = [
  {
    name: "Sustainability",
    desc: "Every project we build is designed to last — for the planet and the people who depend on it.",
    image: "/values-sustainability.jpg",
    color: "#4C9F38",
  },
  {
    name: "Community First",
    desc: "We co-design with communities, not for them. Local voices lead every shelter and solution.",
    image: "/values-community.jpg",
    color: "#26BDE2",
  },
  {
    name: "Youth Leadership",
    desc: "BTSA is built by young Africans, proving the next generation doesn't wait — it builds.",
    image: "/values-youth.jpg",
    color: "#DDA63A",
  },
  {
    name: "Pan-African Vision",
    desc: "Our work transcends borders. 54 nations. One continent. One shared future.",
    image: "/values-africa.jpg",
    color: "#5C3311",
  },
  {
    name: "Innovation",
    desc: "From eco-bricks to biogas, we turn African problems into African solutions.",
    image: "/values-innovation.jpg",
    color: "#E5243B",
  },
];

export const volunteerRoles = [
  { icon: <ConstructIcon />, name: "Projects Team", desc: "Implementation & on-ground community work" },
  { icon: <CampaignIcon />, name: "Communications & PR", desc: "Storytelling, media, and public outreach" },
  { icon: <HandshakeIcon />, name: "Partnership & Donor Engagement", desc: "Building relationships with sponsors and partners" },
  { icon: <DesignIcon />, name: "Content Creation & Design", desc: "Visual storytelling and brand content" },
  { icon: <ResearchIcon />, name: "Research & Documentation", desc: "Data, impact reports, and knowledge management" },
  { icon: <FinanceIcon />, name: "Finance", desc: "Financial planning and accountability" },
];

export const events = [
  {
    day: "22", month: "JAN '26",
    type: "International Summit",
    title: "Africa Summit for Sustainable Development (ASSD 2026)",
    desc: "BTSA participated in Africa's flagship sustainability summit, earning Certificates of Participation.",
    loc: "🌍 Pan-African Conference",
    color: "#1a6b3c", bg: "#e8f5ee",
    image: "ssd.jpg",  // e.g. summit stage, delegates, Africa map backdrop
  },
  {
    day: "29", month: "JAN '26",
    type: "Technology Forum",
    title: "AI-TAP 2.0 — AI for African Progress",
    desc: "BTSA engaged in AI-TAP 2.0, exploring how AI can accelerate development goals across Africa.",
    loc: "🤖 Technology & Innovation",
    color: "#e85d04", bg: "#fff8ee",
    image: "Game.jpg",     // e.g. AI panel, tech speakers, African innovators
  },
  {
    day: "30", month: "JAN '26",
    type: "Webinar · Education",
    title: '"Mastering Your Future" — Scholarship Webinar',
    desc: "Empowering African youth with CV writing and SOP skills to apply for international scholarships.",
    loc: "📚 Youth Empowerment",
    color: "#0369a1", bg: "#eef4ff",
    image: "vision.jpg",     // e.g. online webinar screenshot, youth on laptops, education session
  },
];

export const sdgPills = [
  { num: "4",  label: "Quality Education" },
  { num: "6",  label: "Clean Water" },
  { num: "7",  label: "Clean Energy" },
  { num: "9",  label: "Innovation" },
  { num: "11", label: "Sustainable Cities" },
];

export const navLinks = ["About", "Programs", "Impact", "Events", "Volunteer"];

export const footerColumns = [
  { title: "Programs",      links: ["Eco-Brick Housing", "Biogas Energy", "Water Solutions", "Scholarship Chapter"] },
  { title: "Organization",  links: ["About BTSA", "Our Values", "Impact", "Events"] },
  { title: "Get Involved",  links: ["Volunteer", "Partner With Us", "Contact", "Email Us"] },
];

export const contactDetails = [
  { label: "Email",       value: "africabuildtoshelter@gmail.com" },
  { label: "Phone (Lewis)", value: "+256 761 070 710" },
  { label: "Head Office", value: "Kampala, Central Region, Uganda" },
  { label: "Reach",       value: "Pan-African · All 54 Countries" },
];